import React from 'react'
import {KTSVG} from '../../../_metronic/helpers'

type Props = {
  className?: string
  handleEditModal?: () => void
}

function EditButton({className, handleEditModal}: Props) {
  return (
    <button
      className={`btn btn-light-primary btn-sm px-4 py-1 text-uppercase ${className}`}
      onClick={handleEditModal}
    >
      <KTSVG
        path='/media/icons/duotune/general/gen055.svg'
        className='svg-icon-2 svg-icon-success m-0 '
      />
    </button>
  )
}

export default EditButton
